export type DraftItemFieldKey =
  | "objectType"
  | "objectSubType"
  | "conceptCode"
  | "conceptValues"
  | "assessmentPrompt";

export type DraftItemFieldErrors = Partial<Record<DraftItemFieldKey, string>>;

type DraftItemLike = {
  objectType: string;
  objectSubType: string;
  conceptCode: string;
  conceptValues: unknown[];
  assessmentPrompt: string;
  allValues?: boolean;
};

const REQUIRED_MESSAGES = {
  objectType: "Please select an object type.",
  objectSubType: "Please select an object sub-type.",
  conceptCode: "Please select a concept.",
  conceptValues: "Please select at least one concept value.",
} as const satisfies Partial<Record<DraftItemFieldKey, string>>;

export const PLAN_LIMIT_CONCEPT_ERROR =
  "This concept has reached the maximum plan limit.";

export function validateDraftItem(
  item: DraftItemLike,
  options?: { requireObjectSubType?: boolean },
): DraftItemFieldErrors {
  const errors: DraftItemFieldErrors = {};
  const requireObjectSubType = options?.requireObjectSubType ?? true;

  if (!item.objectType.trim()) {
    errors.objectType = REQUIRED_MESSAGES.objectType;
  }
  if (requireObjectSubType && !item.objectSubType.trim()) {
    errors.objectSubType = REQUIRED_MESSAGES.objectSubType;
  }
  if (!item.conceptCode.trim()) {
    errors.conceptCode = REQUIRED_MESSAGES.conceptCode;
  } else if (!item.allValues && item.conceptValues.length === 0) {
    errors.conceptValues = REQUIRED_MESSAGES.conceptValues;
  }

  return errors;
}

export function hasDraftItemFieldErrors(
  errors: DraftItemFieldErrors,
): boolean {
  return Object.keys(errors).length > 0;
}
